<template lang="html">
    <div class="container-fluid p-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <div class="card-header d-flex justify-content-between align-items-center">
                        <h5 class="mb-0">Receipt Report List</h5>
                        <div class="d-flex align-items-center">
                            <select v-model="currency" class="form-control mr-2" >
                                <option value="">Select Currency</option>
                                <option value="" v-for="(item, index) in currencyList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                            <button class="btn btn-success fbutton mr-2" v-b-modal.bv-modal-csv-upload  @click="calculateAmount()">
                                <i class="fas fa-calculator"></i> Calculate
                            </button>
                            <button class="btn btn-primary fbutton mr-2" v-b-modal.bv-modal-csv-upload  @click="exportCsv()">
                                <i class="fas fa-file-csv"></i> Export CSV
                            </button>
                            <button class="btn btn-secondary fbutton" v-b-modal.bv-modal-csv-upload  @click="exportPdf()">
                                <i class="fas fa-file-pdf"></i> Export PDF
                            </button>
                        </div>
                    </div>
                    </div>
                    <div class="card-body">
                         <div class="row search-form">
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_receipt" class="form-control" placeholder="Search by Receipt Number">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_batch" class="form-control" placeholder="Search by Batch Code, Batch Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_fee" class="form-control" placeholder="Search by Fee Code, Fee Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input type="text" v-model="filter.search_student" class="form-control" placeholder="Search by Student Code, Student Name">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_from" class="form-control" placeholder="From Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <input onfocus="(this.type='date')" v-model="filter.date_to" class="form-control" placeholder="To Date">
                            </div>
                            <div class="col-md-3 mt-1">
                                <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in visibleColumns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sort_by === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <!-- <th>Action</th> -->
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>
                                            <span v-if="user.type == 'a1'">{{ data.receipt_number }}</span>
                                            <span v-else>{{ String((metaData.current_page - 1) * filter.per_page + index + 1).padStart(6, '0') }}</span>
                                            
                                        </td>
                                        <td>{{ data.enrollment.batch.code1 }}{{ data.enrollment.batch.code2 }}{{ data.enrollment.batch.code3 }}</td>
                                        <td>{{ data.enrollment.fee.code }}</td>
                                        <td>{{ data.enrollment.student.student_code }}</td>
                                        <td>{{ data.enrollment.student.name }}</td>
                                        <td>{{ data.date_issued }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.enrollment.original_amount }}</td>
                                        <td>{{ data.enrollment.discount_amount }}</td>
                                        <td>{{ data.enrollment.amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ data.enrollment.remain_amount }}</td>
                                        <td>{{ data.amount }}</td>
                                        <!-- <td>
                                            <a :href="env.webUrl + 'receipt/print-receipt?id=' + data.id" target="_blank" class="btn btn-option text-success"><i class="fas fa-print"></i></a>
                                        </td> -->
                                    </tr>
                                    <tr v-if="dataList.length > 0" class="table-summary font-weight-bold text-white" style="background-color: #4e8889;">
                                        <td class="text-center" colspan="6">
                                           TOTAL
                                        </td>
                                        <td v-if="user.type == 'a1'">{{ totalData.original_enrollment_amount }}</td>
                                        <td>{{ totalData.discount_enrollment_amount }}</td>
                                        <td>{{ totalData.total_enrollment_amount }}</td>
                                        <td v-if="user.type == 'a1'">{{ totalData.remain_enrollment_amount }}</td>
                                        <td>{{ totalData.received_amount }}</td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="table-pagination-minimal">
                            <div class="table-pagination-row">
                                <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                    Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                </div>
                                <nav class="pagination-minimal">
                                    <ul>
                                        <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                            <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                <i class="fas fa-angle-left"></i>
                                            </button>
                                        </li>
                                        <li v-for="page in metaData.last_page" :key="page"
                                            :class="{ 'active':metaData.current_page === page }"
                                            v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                            <button @click.prevent="next(page)">{{ page }}</button>
                                        </li>
                                        <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                            <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                <i class="fas fa-angle-right"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <!-- <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <router-link class="float" to="receipt-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link> -->
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'receiptReportList',
        metaInfo: {
            title: "Receipt Report List",
            titleTemplate: "%s ← MIC",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                user: null,
                alert: "",
                id: '',
                currency: '',
                currencyList: [
                    { id: 1, name: 'USD' },
                    { id: 2, name: 'EUR' },
                    { id: 3, name: 'SGD' },
                    { id: 4, name: 'THB' },
                    { id: 5, name: 'JPY' },
                    { id: 6, name: 'MYR' },
                    { id: 7, name: 'CNY' },
                    { id: 8, name: 'KRW' },
                    { id: 9, name: 'GBP' },
                    { id: 10, name: 'AUD' },
                    { id: 11, name: 'CAD' },
                    { id: 12, name: 'TWD' },
                    { id: 13, name: 'AED' },
                    { id: 14, name: 'INR' },
                    { id: 15, name: 'HKD' },
                    { id: 16, name: 'MOP' },
                    { id: 17, name: 'LAK' },
                    { id: 18, name: 'VND' },
                    { id: 19, name: 'PHP' },
                    { id: 20, name: 'KHR' },
                    { id: 21, name: 'NZD' },
                ],
                totalData: [],
                dataList: [],
                commissionData: [],
                permissions: '',
                columns: {
                    receipt_number: 'Receipt Number',
                    batch_code: 'Batch Code',
                    fee_code: 'Fee Code',
                    student_code: 'Student Code',
                    student_name: 'Student Name',
                    date_issued: 'Receipt Date',
                    original_amount: 'Original Fee',
                    discount_amount: 'Discount Amount',
                    total_amount: 'Total Fee',
                    remain_amount: 'Remain Amount',
                    amount: 'Received Amount',
                },
                filter: {
                    page: 1,
                    per_page: 20,
                    sort_direction: "asc",
                    sort_by: "created_at",
                    limit: 20,
                    search_receipt: '',
                    search_batch: '',
                    search_fee: '',
                    search_student: '',
                    date_from: '',
                    date_to: ''
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
          computed: {
            visibleColumns() {
                // return columns but omit original_amount unless user.type == 'a1'
                const cols = Object.assign({}, this.columns);
                if (!(this.user && this.user.type == 'a1')) {
                    delete cols.original_amount;
                    delete cols.remain_amount;
                }
                return cols;
            },
            visibleColumnsCount() {
                return Object.keys(this.visibleColumns).length;
            }
        },
        methods: {
            ...mapActions({
                getReceiptListAction: 'getReceiptListAction',
                getReceiptCsvExportAction: 'getReceiptCsvExportAction',
                getReceiptPdfExportAction: 'getReceiptPdfExportAction',
                bankDeleteAction: 'bankDeleteAction',
                receiptTotalAction: 'receiptTotalAction',
                getExchangeRateByDayAction: 'getExchangeRateByDayAction'
            }),
            sortBy(column) {
                this.filter.sort_by = column
                if (this.filter.sort_by == column) {
                    if (this.filter.sort_direction == "asc") {
                        this.filter.sort_direction = "desc"
                    } else if (this.filter.sort_direction == "desc") {
                        this.filter.sort_direction = "asc"
                    }
                } else {
                    this.filter.sort_direction = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.currency = ''
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async calculateAmount() {
                if(this.currency == ''){
                    alert("Please select currency")
                    return
                }
                await this.fetchTotalData()
                let option = {
                    startDate: this.filter.date_from || new Date().toISOString().slice(0, 10),
                    currencyId: this.currency || ''
                }
                await this.getExchangeRateByDayAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.totalData.total_enrollment_amount = parseFloat((this.totalData.total_enrollment_amount / res.data).toFixed(2))
                        this.totalData.original_enrollment_amount = parseFloat((this.totalData.original_enrollment_amount / res.data).toFixed(2))
                        this.totalData.discount_enrollment_amount = parseFloat((this.totalData.discount_enrollment_amount / res.data).toFixed(2))
                        this.totalData.remain_enrollment_amount = parseFloat((this.totalData.remain_enrollment_amount / res.data).toFixed(2))
                        this.totalData.received_amount = parseFloat((this.totalData.received_amount / res.data).toFixed(2))
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            async exportCsv() {
                this.isLoading = true;
                let option = this.filter
                await this.getReceiptCsvExportAction({
                    ...option
                }).then(res => {
                    if (res.success == true && res.data.download_url) {
                        console.log('Download URL:', res.data.download_url);
                        
                        // Create a temporary link element to download the file
                        const link = document.createElement('a');
                        link.href = res.data.download_url;
                        link.download = `receipt_report_${new Date().toISOString().slice(0, 10)}.csv`;
                        link.target = '_blank';
                        
                        // Append to body, click, and remove
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        
                        this.isLoading = false;
                    } else {
                        console.error('No download URL received');
                        alert('Failed to generate CSV file');
                        this.isLoading = false;
                    }
                }).catch(err => {
                    console.error('CSV Export Error:', err);
                    alert('An error occurred while exporting CSV');
                    this.isLoading = false;
                })
            },
            async exportPdf() {
                this.isLoading = true;
                let option = this.filter
                await this.getReceiptPdfExportAction({
                    ...option
                }).then(res => {
                    if (res.success == true && res.data.download_url) {
                        console.log('Download URL:', res.data.download_url);
                        
                        // Create a temporary link element to download the file
                        const link = document.createElement('a');
                        link.href = res.data.download_url;
                        link.download = `receipt_report_${new Date().toISOString().slice(0, 10)}.csv`;
                        link.target = '_blank';
                        
                        // Append to body, click, and remove
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        
                        this.isLoading = false;
                    } else {
                        console.error('No download URL received');
                        alert('Failed to generate CSV file');
                        this.isLoading = false;
                    }
                }).catch(err => {
                    console.error('CSV Export Error:', err);
                    alert('An error occurred while exporting CSV');
                    this.isLoading = false;
                })
            },
            async fetchData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.getReceiptListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.last_page
                        this.metaData.current_page = res.data.meta.current_page
                        this.metaData.prev_page_url = res.data.meta.prev_page_url
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.isLoading = false;

                        // Fetch total data
                        this.fetchTotalData()
                    }
                }).catch(err => this.isLoading = true)
            },
            async fetchTotalData() {
                this.isLoading = true
                // Update the page query parameter in the URL
                this.$router.replace({
                    path: this.$route.path,
                    query: {
                        ...this.$route.query,
                        page: this.filter.page
                    }
                });
                let option = this.filter
                await this.receiptTotalAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.totalData = res.data
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'receipt-report-list', 
                    query: {
                        page: 1, 
                        per_page: 10,
                        sort_direction: 'desc', 
                        sort_by: 'created_at',
                        search_receipt: '',
                        search_batch: '',
                        search_fee: '',
                        search_student: '',
                        date_from: '',
                        date_to: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.$router.replace({ 
                    path: 'enrollment-edit', 
                    query: { 
                        page: this.filter.page,
                        per_page: this.filter.per_page,
                        sort_direction: this.filter.sort_direction, 
                        sort_by: this.filter.sort_by, 
                        id: data.id,
                        search_receipt: this.filter.search_receipt,
                        search_batch: this.filter.search_batch,
                        search_fee: this.filter.search_fee,
                        search_student: this.filter.search_student,
                        date_from: this.filter.date_from,
                        date_to: this.filter.date_to
                    } 
                }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.bankDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        mounted() {
            const userStr = window.localStorage.getItem('user');
            console.log(userStr)
            if (userStr) {
                try {
                    this.user = JSON.parse(userStr);
                } catch (e) {
                    this.user = null;
                }
            }

            this.permissions = this.user && this.user.permissions ? this.user.permissions : ''
            this.filter.page = this.$route.query.page
            this.filter.per_page = this.$route.query.per_page
            this.filter.sort_by = this.$route.query.sort_by
            this.filter.sort_direction = this.$route.query.sort_direction
            this.filter.search_receipt = this.$route.query.search_receipt || ''
            this.filter.search_batch = this.$route.query.search_batch || ''
            this.filter.search_fee = this.$route.query.search_fee || ''
            this.filter.search_student = this.$route.query.search_student || ''
            this.filter.date_from = this.$route.query.date_from || ''
            this.filter.date_to = this.$route.query.date_to || ''
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>